import { apple, apricot, bondiBlue, boulder, conifer, curiousBlue, deepCerulean, emperor, frenchPass, hotCinnamon, java, limeade, mineShaft, oregon, sundown, thunderBird, totemPole, veniceBlue } from '../Colors/Colors';
export let CONTEXTS;

(function (CONTEXTS) {
  CONTEXTS["DEFAULT"] = "default";
  CONTEXTS["PRIMARY"] = "primary";
  CONTEXTS["CONFIGURE"] = "configure";
  CONTEXTS["DARK"] = "dark";
})(CONTEXTS || (CONTEXTS = {}));

export const SPINNER_SIZE = {
  'small': '30px',
  'medium': '40px',
  'large': '50px'
};
export const getTheme = {
  'default': {
    mainColor: java,
    shadeColor: bondiBlue,
    tintColor: frenchPass
  },
  'configure': {
    mainColor: deepCerulean,
    shadeColor: veniceBlue,
    tintColor: curiousBlue
  },
  'dark': {
    mainColor: emperor,
    shadeColor: mineShaft,
    tintColor: boulder
  },
  'error': {
    mainColor: thunderBird,
    shadeColor: totemPole,
    tintColor: sundown
  },
  'primary': {
    mainColor: apple,
    shadeColor: limeade,
    tintColor: conifer
  },
  'warning': {
    mainColor: hotCinnamon,
    shadeColor: oregon,
    tintColor: apricot
  }
};